import { AxiosRequestConfig, AxiosResponse } from 'axios';
import AbstractHttpService from '@services/abstractHttpService';

import urls from '@const/urls';
import { IEnvelope, ICurrentEnvelope, IEnvelopesListParams, IDraftEnvelopeData, IEnvelopeParams, IEnvelopeDoHashData, IEnvelopeDoSignData } from '@store/modules/envelopes/types'
import { IParams } from '@app/types';
import { needResetParams } from '@app/const/consts';

class EnvelopesService extends AbstractHttpService {
  private readonly url = urls.envelopes

  async getEnvelopesList ({ direction, boxOguid, page, perPage, otherSearchParams }: IEnvelopesListParams): Promise<AxiosResponse<IEnvelope[]>> {
    const url = this.url.list

    let params : IParams = {}

    direction && (params['direction'] = direction)
    boxOguid && (params['boxOguid'] = boxOguid)
    page && (params['page'] = page)
    perPage && (params['perPage'] = perPage)

    if (otherSearchParams) {
      params={
        ...params,
        ...otherSearchParams
      }
    }

    const config: AxiosRequestConfig = {
      params
    }

    return await this._http.get(url, config)
  }

  async sendEnvelope (data: IDraftEnvelopeData): Promise<AxiosResponse<string>> {
    const url = this.url.list

    return await this._http.post(url, data)
  }

  async getEnvelope ({ oguid, boxOguid }: IEnvelopeParams): Promise<AxiosResponse<ICurrentEnvelope>> {
    const url = this.url.envelope.replace('{{ envelopeOguid }}', oguid).replace('{{ boxOguid }}', boxOguid)

    return await this._http.get(url)
  }

  async postEnvelopeFlowStop (oguid: string): Promise<AxiosResponse> {
    const url = this.url.flowStop.replace('{{ envelopeOguid }}', oguid)

    return await this._http.post(url, {})
  }

  // https://api-gd-backend-dev.dev.info-logistics.eu/specification/redoc.html#tag/envelopes/operation/postHashPdf
  async postEnvelopeDoHash (oguid: string, fileIndex: string, data: IEnvelopeDoHashData): Promise<AxiosResponse<string>> {
    const url = this.url.signing.doHash.replace('{{ envelopeOguid }}', oguid).replace('{{ fileIndex }}', fileIndex)

    const params = needResetParams

    const config: AxiosRequestConfig = {
      params
    }

    return await this._http.post(url, data, config)
  }

  // https://api-gd-backend-dev.dev.info-logistics.eu/specification/redoc.html#tag/envelopes/operation/postSignPdf
  async postEnvelopeDoSign (oguid: string, data: IEnvelopeDoSignData): Promise<AxiosResponse<string[]>> {
    const url = this.url.signing.doSign.replace('{{ envelopeOguid }}', oguid)

    return await this._http.post(url, data)
  }

  // https://api-gd-backend-dev.dev.info-logistics.eu/specification/redoc.html#tag/envelopes/operation/envelopesExcelGet
  /** Получение реестра конвертов */
  async getEnvelopesExcel (params: any): Promise<AxiosResponse> {
    const url = this.url.exportExcel

    const config: AxiosRequestConfig = { params, responseType: 'blob' };

    return await this._http.get(url, config)
  }
}

export default new EnvelopesService()
